@if (!facade.statisticOneComputerLoading()) {
  @if (facade.statisticOneComputerExist()) {
    <mbs-empty-page></mbs-empty-page>
  } @else {
    <div class="mt-5">
      <mbs-add-data-or-run-gsw-hint></mbs-add-data-or-run-gsw-hint>
    </div>
  }
} @else {
  <mbs-loader></mbs-loader>
}
